import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M4.949 7.503 4.5 7.5C.563 7.5 0 8.063 0 12s.563 4.5 4.5 4.5q.232 0 .449-.003 1.456.978 2.917 1.946l1.27.843c2.2 1.465 3.3 2.197 4.082 1.364S14 17.913 14 14.105v-4.21c0-3.808 0-5.712-.782-6.545-.783-.833-1.883-.1-4.083 1.364l-1.269.843c-.974.647-1.947 1.293-2.917 1.946"
                    fill="currentColor"
                />
                <path
                    d="m19.09 12-2.363 2.364L18 15.636l2.364-2.363 2.363 2.363L24 14.364 21.636 12 24 9.636l-1.273-1.272-2.363 2.363L18 8.364l-1.273 1.272z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SpeakerCrossFilledSize24Glyph.displayName = 'SpeakerCrossFilledSize24Glyph';
